const language = {
	'pl': {
		'generalInformation': 'Ogólne informacje',
		'name': 'Nazwa biura',
		'totalArea': 'Całkowita powierzchnia biura',
		'workStations': 'Liczba miejsc pracy',
		'availability': 'Poziom zajęcia (occupancy)',
		'type': 'Typ centrum',
		'style': 'Styl centrum',
		'minLeaseTerm': 'Minimalny okres najmu',
		'maxLeaseTerm': 'Maksymalny okres najmu',
		'status': 'Status',
		'openingDate': 'Data otwarcia centrum',
		'numberOfParkings': 'Liczba miejsc parkingowych',
		'amenities': 'Udogodnienia dla członków',
		'descriptionHeader': 'Opis centrum i lokalizacji',
		'buildingDescription': 'Opis centrum',
		'buildingDescriptionPL': 'Opis centrum PL',
		'buildingDescriptionEN': 'Opis centrum EN',
		'locationDescription': 'Opis lokalizacji',
		'locationDescriptionPL': 'Opis lokalizacji PL',
		'locationDescriptionEN': 'Opis lokalizacji EN',
		'photoDescriptionPL': 'Opis zdjęcia PL',
		'photoDescriptionEN': 'Opis zdjęcia EN',
		'mainPhoto': 'Zdjęcie główne?',
		'website': 'Strona www',
		'city': 'Miasto',
		'street': 'Ulica',
		'showOnWebsite': 'Pokaż na BazaBiur.pl',
		'latitude': 'Szerokość geograficzna',
		'longitude': 'Długość geograficzna',
		'spaceHeader': 'Powierzchnia',
		'parkingSurface': 'Naziemne odkryte',
		'parkingRoofed': 'Naziemne kryte',
		'parkingUnderground': 'Podziemne',
		'parkingGarage': 'Budynek garażowy',
		'guidePricesHeader': 'Guide prices',
		'coworkingHotDesk': 'Coworking hot desk price',
		'coworkingDedicatedDesk': 'Coworking dedicated desk price',
		'average2WS': 'Avg. price for a 2 WS office',
		'average4WS': 'Avg. price for a 4 WS office',
		'average6WS': 'Avg. price for a 6 WS office',
		'additionalCostsHeader': 'Additional costs',
		'deposit': 'Deposit',
		'setupFee': 'Set-up fee',
		'exitFee': 'Exit fee',
		'carParkFee': 'Car park',
		'additionalFees': 'Additional fees',
		'conferenceRooms': 'Conference rooms',
		'additionalComments': 'Additional comments',
		'floor': 'Piętro',
		'area': 'Powierzchnia',
		'from': 'Od',
		'to': 'Do',
		'days': 'dni',
		'value': 'Wartość',
		'currency': 'Waluta',
		'feeType': 'Rodzaj',
	},
	'en': {
		'generalInformation': 'General information',
		'name': 'Office name',
		'totalArea': 'Total area',
		'workStations': 'Work stations',
		'availability': 'Occupancy',
		'type': 'Type of centre',
		'style': 'Style of centre',
		'minLeaseTerm': 'Minimum lease term',
		'maxLeaseTerm': 'Maximum lease term',
		'status': 'Status',
		'openingDate': 'Opening date',
		'numberOfParkings': 'Number of parkings',
		'amenities': 'Amenities',
		'descriptionHeader': 'Centre and location description',
		'buildingDescription': 'Centre description',
		'buildingDescriptionPL': 'Centre description PL',
		'buildingDescriptionEN': 'Centre description EN',
		'locationDescription': 'Location description',
		'locationDescriptionPL': 'Location description PL',
		'locationDescriptionEN': 'Location description EN',
		'photoDescriptionPL': 'Photo description PL',
		'photoDescriptionEN': 'Photo description EN',
		'mainPhoto': 'Main photo?',
		'website': 'Website',
		'city': 'City',
		'street': 'Street',
		'showOnWebsite': 'Show on BazaBiur.pl',
		'latitude': 'Latitude',
		'longitude': 'Longitude',
		'spaceHeader': 'Space',
		'parkingSurface': 'Surface',
		'parkingRoofed': 'Roofed surface',
		'parkingUnderground': 'Underground',
		'parkingGarage': 'Garage building',
		'guidePricesHeader': 'Guide prices',
		'coworkingHotDesk': 'Coworking hot desk price',
		'coworkingDedicatedDesk': 'Coworking dedicated desk price',
		'average2WS': 'Avg. price for a 2 WS office',
		'average4WS': 'Avg. price for a 4 WS office',
		'average6WS': 'Avg. price for a 6 WS office',
		'additionalCostsHeader': 'Additional costs',
		'deposit': 'Deposit',
		'setupFee': 'Set-up fee',
		'exitFee': 'Exit fee',
		'carParkFee': 'Car park',
		'additionalFees': 'Additional fees',
		'conferenceRooms': 'Conference rooms',
		'additionalComments': 'Additional comments',
		'floor': 'Floor',
		'area': 'Area',
		'from': 'From',
		'to': 'To',
		'days': 'days',
		'value': 'Value',
		'currency': 'Currency',
		'feeType': 'Per',
	}
}

export default language


// WEBPACK FOOTER //
// ./src/utils/lang/office.js